import React, { useState } from 'react';
import './SocialShareBar.css';

const SocialShareBar = () => {
  const [copied, setCopied] = useState(false);
  const shareUrl = 'https://irelandvisatracker.in';
  const shareTitle = 'Irish Visa Tracker - Get Instant Alerts';
  const shareText = '🇮🇪 Track your Ireland visa decision instantly! Irish Visa Tracker sends instant email + web push alerts and unlocks all 13 premium tools. ✅ ₹349 one-time ✅ Perfect for Indian applicants';

  const socialLinks = [
    {
      name: 'Facebook',
      icon: 'f',
      color: '#1877F2',
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
      label: 'Share on Facebook'
    },
    {
      name: 'Twitter',
      icon: '𝕏',
      color: '#000000',
      url: `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}`,
      label: 'Share on Twitter'
    },
    {
      name: 'LinkedIn',
      icon: 'in',
      color: '#0A66C2',
      url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`,
      label: 'Share on LinkedIn'
    },
    {
      name: 'Telegram',
      icon: '✈',
      color: '#0088cc',
      url: `https://t.me/share/url?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareText)}`,
      label: 'Share on Telegram'
    },
    {
      name: 'Email',
      icon: '📧',
      color: '#EA4335',
      url: `mailto:?subject=${encodeURIComponent(shareTitle)}&body=${encodeURIComponent(shareText + '\n\n' + shareUrl)}`,
      label: 'Share via Email'
    }
  ];

  const handleShare = (url, name) => {
    window.open(url, '_blank', 'noopener,noreferrer,width=600,height=600');
    
    // Optional: Track share event with analytics
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'share', {
        method: name,
        content_type: 'website',
        item_id: shareUrl
      });
    }
  };

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
      
      // Track copy event
      if (typeof window.gtag !== 'undefined') {
        window.gtag('event', 'share', {
          method: 'Copy Link',
          content_type: 'website',
          item_id: shareUrl
        });
      }
    } catch (err) {
      console.error('Failed to copy link:', err);
    }
  };

  return (
    <div className="social-share-bar">
      <div className="share-bar-container">
        <div className="share-bar-header">
          <span className="share-bar-title">Share Now</span>
        </div>
        
        {socialLinks.map((social) => (
          <button
            key={social.name}
            className="share-button"
            onClick={() => handleShare(social.url, social.name)}
            aria-label={social.label}
            title={social.label}
            style={{ '--share-color': social.color }}
          >
            <span className="share-icon">{social.icon}</span>
          </button>
        ))}
        
        <button
          className={`share-button copy-link-button ${copied ? 'copied' : ''}`}
          onClick={handleCopyLink}
          aria-label="Copy link to clipboard"
          title={copied ? 'Link copied!' : 'Copy link'}
        >
          <span className="share-icon">{copied ? '✓' : '📋'}</span>
        </button>
      </div>
    </div>
  );
};

export default SocialShareBar;
